module.exports = __webpack_public_path__ + "static/media/icon-name.b4024745.png";